var React = require('react');

function ChevronRightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.2072 11.3414L7.10654 0.271408C6.74284 -0.0910751 6.154 -0.0904658 5.79091 0.273283C5.4281 0.636984 5.42903 1.22615 5.79278 1.58892L16.2327 12L5.79241 22.4111C5.4287 22.7739 5.42777 23.3627 5.79053 23.7265C5.97255 23.9088 6.211 24 6.44945 24C6.68729 24 6.92481 23.9094 7.10649 23.7283L18.2072 12.6586C18.3824 12.4844 18.4807 12.2472 18.4807 12C18.4807 11.7529 18.3821 11.516 18.2072 11.3414Z","fill":"white"}));
}

ChevronRightInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ChevronRightInline;

ChevronRightInline.default = ChevronRightInline;
